import { render } from "./main.vue?vue&type=template&id=747d8e23&scoped=true"
import script from "./main.vue?vue&type=script&lang=ts"
export * from "./main.vue?vue&type=script&lang=ts"

import "./main.vue?vue&type=style&index=0&id=747d8e23&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-747d8e23"

export default script